"use client"

import { use } from "react"

import { PublicIntakeFormPublication } from "@/components/public-intake-forms/public-intake-form-publication"

export default function PublicIntakeFormEmbedPage({ params }: { params: Promise<{ token: string }> }) {
  const { token } = use(params)
  return <PublicIntakeFormPublication token={token} />
}
